module.exports = __webpack_public_path__ + "img/icon-thumbs-up-blue.ae91de25.svg";